<!--
 * @Description:销售计划新增/编辑弹出层
 * @Author: Tina
 * @Date: 2023-01-01 11:39:31
 * @LastEditors: Tina
 * @LastEditTime: 2023-01-31 17:08:27
 -->
 <template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="visible"
      width="1000px"
      @close="$emit('update:show',false)">
      <el-form ref="form" :model="form" label-width="80px" :rules="rules">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="模板名称" prop="name">
              {{ form.name }}
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 模板 -->
        <div class="template-box bod">
          <div class="flex-between">
            <div class="template-box-item bd_r">客户等级</div>
            <div class="template-box-item bd_r w120">计划销售占比</div>
            <div class="template-box-item bd_r w120">下单时间</div>
            <div class="template-box-item bd_r w120">抢单时间</div>
            <div class="template-box-item bd_r w220">计划规则</div>
            <div class="template-box-item">备注</div>
          </div>
          <div class="flex-between bd_t">
            <div class="template-box-item bd_r h100">{{ form.level1Name }}</div>
            <div class="template-box-item bd_r w120 h100">{{ form.level1SaleProport }}%</div>
            <div class="template-box-item bd_r w120 h100">{{ form.level1PlaceOrderTime }} 分钟</div>
            <div class="bd_r w120">
              <div class="template-box-item bd_b h50 w120" style="padding-top:16px;">前 {{ form.level1SnatchOrderTimeStart }} 分钟</div>
              <div class="template-box-item h50 w120" style="padding-top:16px;">后 {{ form.level1SnatchOrderTimeEnd }} 分钟</div>
            </div>
            <div class="bd_r w220">
              <div class="template-box-item bd_b h50 w220" style="padding-top:16px;">当前客户等级的单个限量 {{ form.level1PlanningRules1 }}%</div>
              <div class="template-box-item h50 w220" style="padding-top:16px;">当前客户等级的单个限量不限制</div>
            </div>
            <div class="">
              <div class="template-box-item bd_b h50">最小计划量 {{ form.level1PlanningQuantity }} 吨</div>
              <div class="template-box-item h50">/</div>
            </div>
          </div>
          <div class="flex-between bd_t">
            <div class="template-box-item bd_r h130">{{ form.level2Name }}</div>
            <div class="template-box-item bd_r w120 h130">{{ form.level2SaleProport }}%</div>
            <div class="template-box-item bd_r w120 h130">{{ form.level2PlaceOrderTime }} 分钟</div>
            <div class="bd_r w120">
              <div class="template-box-item bd_b h80 w120" style="padding-top:24px;">前 {{ form.level2SnatchOrderTimeStart }} 分钟</div>
              <div class="template-box-item h50 w120" style="padding-top:16px;">后 {{ form.level2SnatchOrderTimeEnd }} 分钟</div>
            </div>
            <div class="bd_r w220">
              <div class="template-box-item bd_b h80 w220" style="padding-top:16px;">
                <div>上一等级客户的单个限量 {{ form.level2PlanningRules1 }}% ✖ {{ form.level2PlanningRules2 }}%</div>
                <div style="margin-top:5px;">当前客户等级的单个限量 {{ form.level2PlanningRules3 }}% ✖ {{ form.level2PlanningRules4 }}%</div>
              </div>
              <div class="template-box-item h50 w220" style="padding-top:16px;">上一等级及当前客户等级的单个限量不限制</div>
            </div>
            <div class="">
              <div class="template-box-item bd_b h80" style="padding-top:24px;">最小计划量 {{ form.level2PlanningQuantity }} 吨</div>
              <div class="template-box-item h50">/</div>
            </div>
          </div>
          <div class="flex-between bd_t">
            <div class="template-box-item bd_r h130">{{ form.level3Name }}</div>
            <div class="template-box-item bd_r w120 h130">{{ form.level3SaleProport }}%</div>
            <div class="template-box-item bd_r w120 h130">{{ form.level3PlaceOrderTime }} 分钟</div>
            <div class="bd_r w120">
              <div class="template-box-item bd_b h80 w120" style="padding-top:24px;">前 {{ form.level3SnatchOrderTimeStart }} 分钟</div>
              <div class="template-box-item h50 w120" style="padding-top:16px;">后 {{ form.level3SnatchOrderTimeEnd }} 分钟</div>
            </div>
            <div class="bd_r w220">
              <div class="template-box-item bd_b h80 w220" style="padding-top:16px;">
                <div>以上等级客户的单个限量 {{ form.level3PlanningRules1 }}% ✖ {{ form.level3PlanningRules2 }}%</div>
                <div style="margin-top:5px;">当前客户等级的单个限量 {{ form.level3PlanningRules3 }}% ✖ {{ form.level3PlanningRules4 }}%</div>
              </div>
              <div class="template-box-item h50 w220" style="padding-top:16px;">以上等级及当前客户等级的单个限量不限制</div>
            </div>
            <div class="">
              <div class="template-box-item bd_b h80" style="padding-top:24px;">最小计划量 {{ form.level3PlanningQuantity }} 吨</div>
              <div class="template-box-item h50">/</div>
            </div>
          </div>
          <div class="flex-between bd_t">
            <div class="template-box-item bd_r">交易客户</div>
            <div class="template-box-item bd_r w120">{{ form.level4SaleProport }}%</div>
            <div class="template-box-item bd_r w120">/</div>
            <div class="template-box-item bd_r w120">/</div>
            <div class="template-box-item bd_r w220">/</div>
            <div class="template-box-item bd_r">/</div>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'infoViewDialog',
  props: ['show', 'info'],
  data () {
    return {
      visible: this.show,
      form: {}
    }
  },
  computed: {
  },
  methods: {
  },
  watch: {
    show (newVal) {
      this.visible = newVal
      if (newVal) {
        this.form = this.info
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-input__inner{
  padding: 0 4px;
}
.inputbox{
  width: 200px;
}
.inputboxsmall{
  width: 140px;
}
.inputboxmini{
  width: 40px;
}
.h50{
  height: 50px;
}
.h80{
  height: 80px;
}
.h100{
  height: 100px;
  padding-top:32px!important;
  // display: flex;
  // text-align: center;
  // align-items: center;
}
.h130{
  height: 130px;
  padding-top:52px!important;
}
.w120{
  width: 120px!important;
}
.w220{
  width: 280px!important;
}
.fs12{
  font-size: 12px;
}
.flex-between{
  display: flex;
  align-items: center;
  // justify-content: space-between;
}
.bod {border: 1px solid #ddd;}
.bd_t {border-top: 1px solid #ddd;}
.bd_b {border-bottom: 1px solid #ddd;}
.bd_r {border-right: 1px solid #ddd;}
.template-box{
  .template-box-item{
    width: 160px;
    padding: 10px 6px;
    text-align: center;
    flex-shrink: 0;
  }
}
</style>
